<div class="content">
    <mat-grid-list cols="1" rowHeight="50vh" gutterSize="15px">
        <mat-grid-tile>
            <ngx-spinner bdColor = "rgba(255, 255, 255, 0.8)" [template]="ThemeService.getSpinnerTemplate()"  size = "medium" color = "#fff" type = "ball-clip-rotate-multiple" [fullScreen] = "false" name="left-panel" >
            </ngx-spinner>
        
            <mat-card appearance="outlined" class="card-data">
                    <mat-card-header>
                        <mat-card-title>Estruturas das Variações</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div class="card-content">
                            <mat-toolbar *ngIf="gridmode">
                                <mat-toolbar-row>
                                    <div class='button'>
                                        <button mat-mini-fab color="primary" (click)="addItem()">
                                            <mat-icon>add</mat-icon>
                                        </button>
                                        <button mat-mini-fab color="warn" (click)="removeItem()">
                                            <mat-icon>remove</mat-icon>
                                        </button>
                                    </div>
                                </mat-toolbar-row>
                            </mat-toolbar>
                            <div class="variation-grid" *ngIf="gridmode">
                                <div *ngFor="let variation of variations" class="lines">
                                    <mat-grid-list cols="7" rowHeight="fit" gutterSize="15px">
                                        <mat-grid-tile colspan="1">
                                            <mat-checkbox [(ngModel)]="variation.selected">
                                            </mat-checkbox>
                                        </mat-grid-tile>
                                        <mat-grid-tile colspan="2" [matTooltip]="variation.name" >
                                            <div  class="long-text">
                                                {{variation.name}}
                                            </div>
                                        </mat-grid-tile>
                                        <mat-grid-tile colspan="3" [matTooltip]="transformArray(variation.option_list)" >
                                            <div  class="long-text">
                                                {{transformArray(variation.option_list)}}
                                            </div>
                                        </mat-grid-tile>
                                        <mat-grid-tile colspan="1">
                                            <button mat-icon-button (click)="editarItem(variation)">
                                                <mat-icon>edit</mat-icon>
                                            </button>
                                        </mat-grid-tile>
                                    </mat-grid-list>
                                </div>

                            </div>
                            <div class="stepper-section" *ngIf="!gridmode">
                                <mat-vertical-stepper [linear]="true" #stepper [animationDuration]="1000">
                                    <mat-step [stepControl]="firstFormGroup">
                                    <form [formGroup]="firstFormGroup">
                                        <ng-template matStepLabel>Preencher o nome da variação</ng-template>
                                        <mat-form-field>
                                        <input matInput placeholder="Cor, Tamanho, Formato, Voltagem" formControlName="name" required>
                                        </mat-form-field>
                                        <div>
                                        <button mat-button matStepperNext (click)="proximo()">{{'next'|translateTA}}</button>
                                        </div>
                                    </form>
                                    </mat-step>
                                    <mat-step [stepControl]="secondFormGroup">
                                        <form [formGroup]="secondFormGroup">
                                            <ng-template matStepLabel>Informar as opções </ng-template>
                                                <div *ngIf="selectedVariation">
                                                    <div class="data-selection">
                                                        <strong>Valores informados para {{selectedVariation.name}}</strong>
                                                        
                                                        <mat-form-field class="chip-list">
                                                            <mat-chip-grid #chipList aria-label="Variação Seleção" [formControl]="opcao">
                                                                <mat-chip-row *ngFor="let option of selectedVariation.option_list" 
                                                                (removed)="remove(option)"
                                                                [selected]="option.option"  [selectable]="selectable" [removable]="true" color='primary' selected class="mat-chip mat-focus-indicator mat-standard-chip mat-primary mat-chip-selected">
                                                                    {{option.option}}
                                                                <button matChipRemove>
                                                                    <mat-icon>cancel</mat-icon>
                                                                </button>
                                                                </mat-chip-row>
                                                                
                                                                <input [placeholder]="'Inserir '+selectedVariation.name+ '...'"
                                                                    [matChipInputFor]="chipList"
                                                                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                                                    [matChipInputAddOnBlur]="addOnBlur"
                                                                    (matChipInputTokenEnd)="add($event)"
                                                                    >    
                                                            </mat-chip-grid>
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            <div>
                                                <button mat-button matStepperPrevious>Voltar</button>
                                                <button mat-button matStepperNext>Próximo</button>
                                            </div>
                                        </form>
                                    </mat-step>
                                    <mat-step>
                                    <ng-template matStepLabel>Selecionar Imagens</ng-template>
                                    <mat-selection-list #opcoes [multiple]="false" *ngIf="selectedVariation">
                                        <mat-list-option *ngFor="let item of selectedVariation.option_list" [value]="item.option" (click)="clickAction(item)"   cdkOverlayOrigin #trigger="cdkOverlayOrigin">
                                            <div class="item-option-detail">
                                                <mat-icon mat-list-icon [color]="hasImage(item) ? 'success':'primary'">image</mat-icon>
                                                <div mat-line>{{item.option}}</div>
                                            </div>
                                            <ng-template
                                                    cdkConnectedOverlay
                                                    [cdkConnectedOverlayOrigin]="trigger"
                                                    [cdkConnectedOverlayOpen]="item.hover"
                                                    [cdkConnectedOverlayPositions]="positionPairs"
                                                    [cdkConnectedOverlayDisableClose]="true">
                                                    <div class="image-selection">
                                                        <div class="image-gallery-container" *ngIf="shopeeImages.length > 0">
                                                            <div class="gallery" *ngFor="let imageData of shopeeImages" (click)="imageAction(item,imageData.image_id)" [ngStyle]="{'margin':getImageById(item,imageData.image_id)?'3px':'0'}">
                                                                <img [src]="imageData.image" >
                                                                
                                                                <!--div class="circle-check" [hidden]="!getImageById(item,imageData.image_id)"-->
                                                                <div class="circle-check" [hidden]="!getImageById(item,imageData.image_id)">
                                                                    <mat-icon  class="check-image">check</mat-icon>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div *ngIf="shopeeImages.length == 0">
                                                            <div class="no-data">
                                                                <strong>Não existem imagens para esse produtos.</strong>
                                                            </div>
                                                            
                                                        </div>
                                                        <div class="action-image-buttons" >
                                                            <actions-buttons [buttonList]="buttonListImage" [data]="{item:item , images:item.image}"></actions-buttons>
                                                        </div>
                                                    </div>
                                            </ng-template>
                                        </mat-list-option>
                                      </mat-selection-list>
                                    <div>
                                        <button mat-button matStepperPrevious>Voltar</button>
                                        <button mat-button (click)="finalizar()">Finalizar</button>
                                    </div>
                                    </mat-step>
                                </mat-vertical-stepper>
                            </div>
                        </div>
                    </mat-card-content>
            </mat-card>            
            
        </mat-grid-tile>
    </mat-grid-list>
    
</div>
